export const HeaderHeight = 60
export const HeaderLogoSize = 145
export const HeaderLogoWidthForSP = 45
